import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import api from '../services/axiosInterceptor.js';

export default function EbayAuthCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const started = useRef(false);
    const [message, setMessage] = useState('Finishing eBay connection...');

    useEffect(() => {
        if (started.current) return;
        started.current = true;

        const code = searchParams.get('code');
        const oauthError = searchParams.get('error_description') || searchParams.get('error');

        const finish = (ebay) => {
            const params = new URLSearchParams({ page: '4', ebay });
            navigate(`/manage-account?${params.toString()}`, { replace: true });
        };

        if (oauthError) {
            finish('denied');
            return;
        }
        if (!code) {
            finish('missing');
            return;
        }

        api.post('/api/broylesllc/integrations/ebay/callback', { code })
            .then(() => finish('connected'))
            .catch((err) => {
                console.error(err);
                setMessage(err?.response?.data?.message ?? 'Failed to reconnect eBay.');
                setTimeout(() => finish('error'), 1200);
            });
    }, [navigate, searchParams]);

    return (
        <div className="d-flex flex-column align-items-center pt-5">
            <CircularProgress size={24} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                {message}
            </Typography>
        </div>
    );
}
